// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { InputTokens } from './type';

const inputTokens: InputTokens = {
  inputFontSize: '14/regular',
  inputBorderRadius: 'Radius-4',
  inputPaddingX: 'Padding-8',
  inputPaddingY: 'Padding-4',
  inputIconSize: 'Size-7',
  inputSmallFontSize: '12/regular',
  inputSmallPaddingX: 'Padding-8',
  inputSmallPaddingY: 'Padding-1',
  inputLargeFontSize: '16/regular',
  inputLargePaddingX: 'Padding-12',
  inputLargePaddingY: 'Padding-7',
  inputFontColor: 'Neutral-text-5',
  inputPlaceholderColor: 'Neutral-text-2',
  inputBorderColor: 'Neutral-border-2',
  inputBackgroundColor: 'Neutral-fill-1',
  inputClearColor: 'Neutral-text-3',
  inputToggleColor: 'Neutral-text-4',
  inputIconColor: 'Neutral-text-4',
  inputHoverBorderColor: 'Brand-6',
  inputHoverClearColor: 'Neutral-text-4',
  inputHoverToggleColor: 'Neutral-text-5',
  inputFocusBorderColor: 'Brand-7',
  inputFocusShadow: 'Brand-2',
  inputDisabledFontColor: 'Neutral-text-2',
  inputDisabledPlaceholderColor: 'Neutral-text-2',
  inputDisabledBorderColor: 'Neutral-border-1',
  inputDisabledBackgroundColor: 'Neutral-fill-2',
  inputErrorBorderColor: 'Danger-6',
  inputErrorFocusShadow: 'Danger-1',
  inputInfoFontColor: 'Brand-6',
  inputInfoBackgroundColor: 'Neutral-fill-1',
  inputInfoBorderColor: 'Neutral-border-2',
  inputInfoErrorFontColor: 'Danger-6',
  inputInfoErrorBackgroundColor: 'Danger-1',
  inputInfoErrorBorderColor: 'Danger-6',
  inputInnerPaddingX: 'Padding-8',
  inputInnerPaddingY: 'Padding-1',
  inputInnerFontSize: '12/regular',
  inputInnerSmallPaddingX: 'Padding-8',
  inputInnerSmallPaddingY: 'Padding-1',
  inputInnerSmallFontSize: '12/regular',
  inputInnerLargePaddingX: 'Padding-12',
  inputInnerLargePaddingY: 'Padding-3',
  inputInnerLargeFontSize: '14/regular',
  inputInnerFontColor: 'Neutral-text-4',
};

export default inputTokens;
